import React, {useEffect, useRef, useState} from "react";
import {Button, Card} from "react-bootstrap";
export default function CameraCapture({
                                          setFile
                                      }) {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const streamRef = useRef(null);
    const [cameraActive, setCameraActive] = useState(false);
    const [preview, setPreview] = useState("");
    // =====================================================
    // START CAMERA
    // =====================================================
    const startCamera = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: {
                        ideal: "environment"
                    },
                    width: {
                        ideal: 1920
                    },
                    height: {
                        ideal: 1080
                    }
                },
                audio: false
            });
            console.log("STREAM", stream);
            streamRef.current = stream;
            setCameraActive(true);
            // Wait until the <video> is rendered
            setTimeout(() => {
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                    const track = stream.getVideoTracks()[0];
                    console.log(track.getSettings());
                    videoRef.current.onloadedmetadata = () => {
                        console.log("Video Size",
                            videoRef.current.videoWidth,
                            videoRef.current.videoHeight
                        );
                        videoRef.current.play();
                    };
                }
            }, 100);
        } catch (err) {
            console.log(err);
        }
    };
    // =====================================================
    // STOP CAMERA
    // =====================================================
    const stopCamera = () => {
        if (streamRef.current) {
            streamRef.current
                .getTracks()
                .forEach(track => {
                    track.stop();
                });
        }
        setCameraActive(false);
    };
    // =====================================================
    // CAPTURE IMAGE
    // =====================================================
    const captureImage = () => {
        const video = videoRef.current;
        const canvas = canvasRef.current;
        if (!video || !canvas) return;
        if (video.videoWidth === 0 || video.videoHeight === 0) {
            alert("Camera is still loading. Please wait a second.");
            return;
        }
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");
        console.log(
            "Video:",
            video.videoWidth,
            video.videoHeight,
            video.readyState
        );
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const data = canvas.toDataURL("image/jpeg");
        console.log(data.substring(0, 80));
        window.open(data);
        canvas.toBlob((blob) => {
            if (!blob) {
                alert("Unable to capture image.");
                return;
            }
            const imageFile = new File([blob], "camera_identity.jpg", {
                type: "image/jpeg"
            });
            setFile(imageFile);
            setPreview(URL.createObjectURL(imageFile));
            stopCamera();
        }, "image/jpeg", 0.95);
    };
    // =====================================================
    // CLEANUP
    // =====================================================
    useEffect(() => {
        return () => {
            stopCamera();
        };
    }, []);
    return (<Card className="mt-3">


        <Card.Body>


            <h6>
                📷 Camera Capture
            </h6>


            {!cameraActive && (<Button

                variant="dark"

                className="w-100"

                onClick={startCamera}

            >

                Open Camera

            </Button>)}


            {cameraActive && (<>


                <video
                    ref={videoRef}
                    autoPlay
                    muted
                    playsInline
                    style={{
                        width: "100%",
                        height: "420px",
                        objectFit: "cover",
                        background: "#000",
                        borderRadius: "15px"
                    }}
                />
                <Button

                    variant="success"

                    className="w-100 mt-3"

                    onClick={captureImage}

                >

                    📸 Capture Document


                </Button>


            </>)}


            <canvas

                ref={canvasRef}

                style={{
                    display: "none"
                }}

            />


            {preview && (<div className="mt-3">


                <h6>
                    Captured Preview
                </h6>


                <img

                    src={preview}

                    alt="capture"

                    style={{
                        width: "100%", borderRadius: "15px"
                    }}

                />


            </div>)}


        </Card.Body>


    </Card>);
}